import styled from 'styled-components';
import theme from 'styles/theme';

/* Hub Wrapper */
const Loading = styled.p`
  font-family: ${theme.fontPrimary};
`;

export default {
  Loading,
};
